const department = [{
    id: 1,
    name: '前厅客房部'
  },
  {
    id: 2,
    name: '市场营销部'
  },
  {
    id: 4,
    name: '餐饮娱乐部'
  },
  {
    id: 8,
    name: '餐饮娱乐部'
  },
  {
    id: 16,
    name: '人力资源部'
  },{
    id: 32,
    name: '财务管理部'
  },
  {
    id: 64,
    name: '工程运维部'
  }
]
const departments = [{
  id: 1,
  name: '前厅客房部'
},
{
  id: 2,
  name: '市场营销部'
},
{
  id: 4,
  name: '餐饮部'
},
{
  id: 8,
  name: '娱乐部'
},
{
  id: 16,
  name: '人力资源部'
},{
  id: 32,
  name: '财务管理部'
},
{
  id: 64,
  name: '工程运维部'
}
]
const education=[{
  id:0,
  name:'博士'
},
{
  id:1,
  name:'硕士'
},
{
  id:2,
  name:'本科'
},
{
  id:3,
  name:'高职'
},
{
  id:4,
  name:'中职'
},]
const sex=[{
  id:0,
  name:'男'
},{
  id:1,name:'女'
}]
const Affair = [{
  value: 0,
  label: "婚宴",
}, {
  value: 1,
  label: "政府会议",
}, {
  value: 2,
  label: "企业内部活动",
}, {
  value: 3,
  label: "庆典活动",
}, {
  value: 4,
  label: "公益活动",
}, {
  value: 5,
  label: "学术会议",
}, {
  value: 6,
  label: "商业会议",
}, {
  value: 7,
  label: "丧宴",
}]
const AffairState=[{
  value:0,
  label:'等待处理'
},{
  value:1,
  label:'接受'
},{
  value:-1,
  label:'拒绝'
},{
  value:-2,
  label:'删除'
},]


const MarketReport={
  Customertype:0,
  MarkType :1,
      HotSelfDishs: 2,
      HotFlavorDishs : 3,
      PopularActivities : 4,
      HotBarDish : 5
}
const WorkDay =[{
  Rest : 0,//休息
  Sunday : 1, //周日
  Monday : 2,//周一
  Tuesday : 4,//周二
  Wednesday : 8,//周三
  Thursday : 16,//周四
  Friday :32,//周五
  Saturday : 64//周六
}]
function paymentMany(money) {
let Maney =  localStorage.getItem("Money")
Maney-=money;
localStorage.setItem("Money",Maney)
}
function AddMany(money) {
  let Maney =  localStorage.getItem("Money")
  Maney+=money;
  localStorage.setItem("Money",Maney)
  }
export default {
  department,
  education,
  sex,
  WorkDay,
  departments,
  MarketReport,
  paymentMany,
  AddMany,
  Affair,
  AffairState,
};